import { render, staticRenderFns } from "./ShadowBtn2.vue?vue&type=template&id=cf37087e&scoped=true"
import script from "./ShadowBtn2.vue?vue&type=script&lang=js"
export * from "./ShadowBtn2.vue?vue&type=script&lang=js"
import style0 from "./ShadowBtn2.vue?vue&type=style&index=0&id=cf37087e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf37087e",
  null
  
)

export default component.exports